module.exports = "pegasus/assets/blocks/column-3-theme5.png";